import React, { useEffect, useMemo, useState } from "react";
import { useAuth } from "../../components/context/AuthContext";
import api from "../../api";
import { organizationEndpoints } from "../../api/apiEndpoints";
import Copilot from "./Copilot";
import useCopilotReportContext from "./useCopilotReportContext";

export default function CopilotWithOrg(props) {
  const { isAuthenticated, user } = useAuth();
  const { backendApiUrl, reportId, toolType, authToken } = useCopilotReportContext();
  const [orgData, setOrgData] = useState(null);

  useEffect(() => {
    if (!isAuthenticated) {
      setOrgData(null);
      return;
    }

    let cancelled = false;

    api
      .get(organizationEndpoints.getOrganization)
      .then((res) => {
        if (!cancelled) setOrgData(res.data);
      })
      .catch(() => {
        if (!cancelled) setOrgData(null);
      });

    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, user?.id]);

  const organizationId = useMemo(
    () => orgData?.id || user?.organization?.id || null,
    [orgData?.id, user?.organization?.id],
  );

  return (
    <Copilot
      {...props}
      organizationId={organizationId}
      backendApiUrl={backendApiUrl}
      reportId={reportId}
      toolType={toolType}
      authToken={authToken}
    />
  );
}
